/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  work_id: z.number(),
  work_type_id: z.number(),
  work_subtype_id: z.number(),
  location_slot1: z.string(),
  location_slot2: z.string(),
  planned_qty: z.number(),
  unit: z.string(),
  remarks: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  location_slot1: base.shape.location_slot1.optional(),
  location_slot2: base.shape.location_slot2.optional(),
  planned_qty: base.shape.planned_qty.optional(),
  unit: base.shape.unit.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const QuantityPlanBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type QuantityPlanBase = z.infer<typeof base>;
export type QuantityPlanBasePutPayload = z.infer<typeof put>;
export type QuantityPlanBasePatchPayload = z.infer<typeof patch>;
export type QuantityPlanBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type QuantityPlanBaseCreateAttributes = z.infer<typeof create>;
export type QuantityPlanBaseUpdateAttributes = z.infer<typeof update>;
export type QuantityPlanBaseCacheAttributes = z.infer<typeof cache>;
export type QuantityPlanBaseCachesAttributes = z.infer<typeof caches>;